import PersonIcon from '@mui/icons-material/Person';
import {
  setActiveMissionVersionId,
  setActiveWorkspaceId,
  setLatestJobId,
  setUserId,
} from 'components/RootView/missionExplorerSlice';
import Nav from 'components/general/Nav';
import StyledButton from 'components/general/StyledButton';
import ViewContainer from 'components/general/ViewContainer';
import ViewPort from 'components/general/ViewPort';
import WGroup from 'components/general/WGroup';
import { useSnackbar, useUser } from 'hooks';
import { SatelliteApi } from 'middleware/SatelliteApi/api';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ApiKeysWidget from './ApiKeysWidget';
import PasswordWidget from './PasswordWidget';
import UserInfoWidget from './UserInfoWidget';

const ManagementConsoleView = () => {
  const {
    User: {
      actions: { logout },
    },
  } = SatelliteApi;

  const dispatch = useDispatch();

  const user = useUser();

  const { closeSnackbar } = useSnackbar();

  // Unset active mission version ID whenever user navigates to workspaces. This unsets the nav bar.
  // Unset latest job ID so ActiveBranch provider knows to fetch a new one when switching between repos.
  useEffect(() => {
    dispatch(setActiveWorkspaceId(undefined));
    dispatch(setActiveMissionVersionId(undefined));
    dispatch(setLatestJobId(undefined));
  }, [dispatch]);

  return (
    <ViewContainer>
      <Nav
        contextIcon={<PersonIcon />}
        contextName={'Management Console'}
        contextHeader={user.firstName + ' ' + user.lastName}
        contextSubHeader={'User since ' + moment(user.dateCreated).format('MMMM YYYY')}
      >
        <StyledButton
          type="button"
          onClick={() => {
            closeSnackbar();
            dispatch(
              logout({
                successCallback: (params: { redirect?: string }) => {
                  dispatch(setUserId(undefined));
                  if (params.redirect) {
                    window.location.href = params.redirect;
                  }
                },
              })
            );
          }}
          framed
          tallMargin
          fullWidth
        >
          Logout
        </StyledButton>
      </Nav>
      <ViewPort>
        <WGroup>
          <ApiKeysWidget />
        </WGroup>
        <WGroup maxWidth={800} masonryConfig={{ 750: [50, 50] }}>
          <UserInfoWidget />
          {!user.externalIdentityProvider && <PasswordWidget />}
        </WGroup>
      </ViewPort>
    </ViewContainer>
  );
};

export default ManagementConsoleView;
